export interface TimeBounds {
  start: Date;
  end: Date;
}

/**
 * Clamp a selected range to event bounds and optionally cap both ends at the current instant
 * (for live events where observation data cannot exist in the future).
 */
export function clampTimelineSelection(
  start: Date,
  end: Date,
  eventBounds: TimeBounds,
  clampToNow: boolean
): { start: Date; end: Date } {
  let s = start.getTime();
  let e = end.getTime();
  if (s > e) {
    const t = s;
    s = e;
    e = t;
  }

  const evS = eventBounds.start.getTime();
  const evE = eventBounds.end.getTime();
  s = Math.max(s, evS);
  e = Math.min(e, evE);

  if (clampToNow) {
    const now = Date.now();
    e = Math.min(e, now);
    s = Math.min(s, e);
  }

  if (s > e) s = e;

  return { start: new Date(s), end: new Date(e) };
}

/**
 * Convert a date to its pixel position on the timeline.
 */
export function dateToX(
  date: Date,
  bounds: TimeBounds,
  width: number
): number {
  const totalDuration = bounds.end.getTime() - bounds.start.getTime();
  const elapsed = date.getTime() - bounds.start.getTime();
  return (elapsed / totalDuration) * width;
}

/**
 * Convert a pixel position to its corresponding date on the timeline.
 */
export function xToDate(x: number, bounds: TimeBounds, width: number): Date {
  const totalDuration = bounds.end.getTime() - bounds.start.getTime();
  const elapsed = (x / width) * totalDuration;
  return new Date(bounds.start.getTime() + elapsed);
}
